const colors = {
  // Màu chính từ bảng màu mới
  primary: '#6C7EE1',    // Màu xanh dương đậm
  secondary: '#92B9E3',  // Màu xanh dương nhạt
  tertiary: '#FFC4A4',   // Màu cam nhạt
  quaternary: '#FBA2D0', // Màu hồng
  quinary: '#C688EB',    // Màu tím

  // Màu nền
  background: '#e0eefd', // Trắng cho nền ch
  backgroundAlt: '#f4f4f4',

  // Màu văn bản
  textPrimary: '#212529',
  textSecondary: '#6c757d',
  textLight: '#ffffff',

  // Màu viền
  border: '#dee2e6',

  // Màu liên kết
  link: '#007bff',
  linkHover: '#0056b3',

  // Màu disable
  disabled: '#e9ecef',

  // Màu overlay
  overlay: 'rgba(0, 0, 0, 0.5)',

  // Thêm các màu tùy chỉnh khác nếu cần
  // customColor1: '#...',
  // customColor2: '#...',
};

export default colors;
